<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search">
                <div class="search_item">
                    <div class="title">
                        名字:
                    </div>
                    <div class="input-box">
                        <el-input v-model="searchForm.input"
                                  placeholder="请输入姓名、用户名"
                                  @change="getTableData()"
                                  size="small"
                                  class="width_300"
                                  clearable>
                            <el-button slot="append"
                                       @click="getTableData()"
                                       icon="el-icon-search"></el-button>
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="btn-box">
                <el-button class="new_btn"
                           @click="openNew"
                           type="primary"
                           size="small">新建用户
                </el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column
                    prop="department_list"
                    label="负责区域"
                    :formatter="showArea"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope" v-if="scope.row.is_operation">
                        <el-tag
                            style="display:block;width: fit-content;margin-bottom: 5px;"
                            :key="tagIndex"
                            v-for="(tag,tagIndex) in scope.row.department_list"
                            closable
                            :disable-transitions="false"
                            size="small"
                            @close="deleteDepartment(scope.row,tag)">
                            {{tag.department_name}}
                        </el-tag>
                        <el-tag
                            style="cursor:pointer;"
                            :disable-transitions="false"
                            type="info"
                            size="small"
                            @click="addDepartment(scope.row)">
                            添加
                            <i class="el-icon-plus"></i>
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="resetRow(scope.row)">
                            <i class="el-icon-refresh-left"></i>
                            重置密码
                        </span>
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--
                <div class="bottom_page">
                    <page-view @getTableList="handleCurrentChange"
                               :currentPage="currentPage"
                               :pageSize="pageSize"
                               :total="total"></page-view>
                </div>-->

        <el-dialog :title="dialogTitle"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   :modal="false"
                   width="500px">
            <el-form :model="userForm"
                     ref="userForm"
                     :rules="rules"
                     label-width="100px">
                <el-form-item label="姓名:" prop="name">
                    <el-input v-model="userForm.name"
                              clearable
                              :maxlength="6"
                              class="width_220"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="phone">
                    <el-input v-model="userForm.phone"
                              clearable
                              :maxlength="16"
                              :minlength="1"
                              class="width_220"></el-input>
                </el-form-item>

                <el-form-item label="角色:">
                    <el-select v-model="userForm.role_list"
                               multiple
                               class="width_300"
                               placeholder="可多选">
                        <el-option
                                v-for="(item, index) in roleList"
                                :key="index"
                                :label="item.name"
                                :value="item.role_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="负责区域:">
                    <el-cascader v-model="userForm.department_ids"
                                 :options="areaData"
                                 :props="props"
                                 filterable
                                 :show-all-levels="false"
                                 class="width_300"
                                 clearable></el-cascader>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="添加负责区域" width="450px" :modal="false" :close-on-click-modal="false"
                   :close-on-press-escape="false" :show-close="false" :visible.sync="change_tree">
            <el-form :model="department" label-width="120px">
                <el-form-item label="部门名称" prop="name">
                    <el-cascader v-model="department.department_id" :options="areaData" :props="treeOptions" filterable
                                 :show-all-levels="false" clearable></el-cascader>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="change_tree = false">取 消</el-button>
                <el-button type="primary" @click="departmentChange">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        components: {},
        data() {
            const showRole = (row, column, cellValue, index) => {
                let text = '';
                if (!cellValue || cellValue.length === 0) return text;
                cellValue.forEach(e => {
                    this.roleList.forEach(i => {
                        if (e == i.role_id) {
                            if (text === '') {
                                text = i.name
                            } else {
                                text = text + '、' + i.name
                            }
                        }
                    })
                });
                return text
            };
            const showArea = (row, column, cellValue, index) => {
                let text = '';
                if (!cellValue || cellValue.length === 0) return text;
                cellValue.forEach(e => {
                    if (text === '') {
                        text = e.name
                    } else {
                        text = text + '、' + e.name
                    }
                });
                return text
            };
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入手机号!'))
                }
                setTimeout(() => {
                    if (value.length !== 11) {
                        callback(new Error('手机号码请输入11位！'));
                    }
                    if (!(/^1[3456789]\d{9}$/.test(value))) {
                        callback(new Error('请输入正确的手机号！'));
                    } else {
                        callback()
                    }
                }, 50);
            };
            return {
                searchForm: {
                    input: '',
                },
                tableData: [],
                columnData: [
                    {label: '姓名', prop: 'name',width:"140"},
                    {label: '手机号', prop: 'phone',width:"140"},
                    {label: '角色', prop: 'role_list',width:"", formatter: showRole},
                    // {label: '负责区域', prop: 'department_list', formatter: showArea},

                ],
                showArea: showArea,
                department:{
                    //新添加复制区域
                    department_id: ''
                },
                change_tree:false,
                addUser_id: '', //哪个用户添加区域
                treeOptions: {
                    checkStrictly: true,
                    emitPath: false,
                    expandTrigger: 'hover',
                    value: 'department_id',
                    label: 'name',
                    children: 'children'
                },
                total: 0,
                currentPage: 1,
                pageSize: 10,

                roleList: [],
                dialogVisible: false,
                dialogTitle: '新建用户',
                userForm: {
                    name: '',
                    phone: '',
                    role_list: [],
                    department_ids: []
                },
                rules: {
                    name: [{required: true, message: '请输入姓名!', trigger: 'blur'}],
                    phone: [{required: true, validator: checkPhone, trigger: 'blur'}],
                    role_list: [{required: true, message: '请选择角色!', trigger: 'blur'}],
                },

                props: {
                    multiple: true,
                    value: 'department_id',
                    label: 'name',
                    checkStrictly: true,
                    emitPath: false
                },
                areaData: []
            }
        },
        computed: {
            ...mapState("manageData", {
                treeDataAll: 'treeDataAll'
            }),
        },
        mounted() {
            this.getTableData();
            this.getRoleList();
            this.getArea();
        },
        methods: {
            deleteDepartment(row,dep){
                let params = {
                    is_delete: 1,//删除
                    department_id: dep.department_id,
                    user_id: row.user_id
                }
                // console.log("删除负责区域.....",params)
                this.httpGet("/user/operation/department/update",params).then(res =>{
                    this.getTableData();
                    this.getRoleList();
                })
            },
            addDepartment(row){
                // console.log("add.....",row)
                this.addUser_id = row.user_id;
                this.change_tree = true;
            },
            departmentChange(){
                let params = {
                    department_id: this.department.department_id,
                    user_id: this.addUser_id
                }
                // console.log('添加负责区域。。。',params)
                this.httpGet("/user/operation/department/update",params).then(res =>{
                    this.change_tree = false;
                    this.addUser_id = '';
                    this.getTableData();
                    this.getRoleList();
                })
            },
            getArea() {
                this.httpGet('/department').then(res => {
                    // console.log(res)
                    this.areaData = res.data;

                    const selectChildren = function (list) {
                        list.forEach(v => {
                            if (v.children && v.children.length > 0) {
                                selectChildren(v.children)
                            } else {
                                v.children = null
                            }
                        })
                    };
                    selectChildren(this.areaData)
                })
            },

            getRoleList() {
                let params = {is_all: 2};
                this.httpGet('/role', params).then(res => {
                    this.roleList = res.data.data_list;
                })
            },
            openNew() {
                this.dialogTitle = '新建用户';
                this.userForm = {
                    name: '',
                    phone: '',
                    role_list: [],
                    department_ids: []
                };
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.$refs.userForm.clearValidate()
                })
            },
            resetRow(row) {
                this.$confirm('确定要重置该用户的密码么？').then(() => {
                    // console.log(row, 'reset');
                    let params = {
                        user_id: row.user_id
                    };
                    this.httpGet('/user/password/reset', params).then(res => {
                        this.$message.success('重置密码成功！');
                    })
                })
            },
            editRow(row) {
                console.log(row);
                this.dialogTitle = '修改用户';
                this.userForm = clone(row);
                this.userForm.department_ids = this.userForm.department_ids.split(',');

                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.$refs.userForm.clearValidate()
                })
            },
            submit() {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        let params = this.userForm;
                        console.log(params, '271');
                        params.department_ids = params.department_ids.join(',');
                        if (this.dialogTitle === '新建用户') {
                            this.httpPost('/user/admin', params).then(res => {
                                if (res.duplicate) {
                                    this.$message.warning(this.dialogTitle + '重复');
                                } else {
                                    this.$message.success(this.dialogTitle + '成功');
                                    this.getTableData(this.currentPage);
                                    this.dialogVisible = false;
                                }
                            })
                        } else {
                            this.httpPut(`/user/admin/${params.user_id}`, params).then(res => {
                                if (res.duplicate) {
                                    this.$message.warning(this.dialogTitle + '重复');
                                } else {
                                    this.$message.success(this.dialogTitle + '成功');
                                    this.getTableData(this.currentPage);
                                    this.dialogVisible = false;
                                }
                            })
                        }

                    } else {
                        return false
                    }
                })
            },

            delRow(row) {
                // 当前页全部删除后进入上一页
                let listLength = this.tableData.length;
                let nowPage = this.currentPage;
                if (listLength === 1) {
                    if (this.currentPage > 1) {
                        nowPage = this.currentPage - 1
                    } else {
                        nowPage = 1
                    }
                }

                this.$confirm('是否删除该用户?').then(res => {
                    this.httpDel(`/user/admin/${row.user_id}`).then(res => {
                        if (res.code === 0) {
                            this.$message.success('已成功删除！');
                            this.getTableData(nowPage);
                        }
                    })
                })
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                console.log('get_data');
                let params = {
                    name: this.searchForm.input,
                    // page: v,
                    // page_size: this.pageSize
                };
                this.httpGet('/user/admin', params).then(res => {
                    this.tableData = res.data.data_list;

                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>